
// SVG Icon: trashcan
export default { id: "terriajs-trashcan" };
export const id = "terriajs-trashcan";
export const name = "trashcan";
